export interface ForgetPasswordRequestModel {
  email: string;
  verificationCode: string;
}
